import Vue from 'vue';
import Router from 'vue-router';
import Home from './views/Home.vue';
// import Download from './views/Download.vue';
import Protocol from './views/Protocol.vue';

// import Change from './views/Change.vue';

Vue.use(Router);

import { isZnWebsite } from "@/utils/isZnWebsite";
const title = isZnWebsite ? '博纳云：全球泛载雾计算平台' : 'BonusCloud: The Worldwide Universally-carried Fog Computing Platform';

// const title = 'BonusCloud: The next generation infrastructure driven by blockchain';

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'home',
      meta: {
        title,
      },
      component: Home,
    },
    // {
    //   path: '/download',
    //   name: 'download',
    //   meta: {
    //     title,
    //   },
    //   component: Download,
    // },
    {
      path: '/protocol',
      name: 'protocol',
      meta: {
        title,
      },
      component: Protocol,
    },
    {
      path: '*',
      redirect:'/',
    },  

    // {
    //   path: '/protocol',
    //   name: 'Protocol',
    //   meta: {
    //     title,
    //   },
    //   component: Protocol,
    // },
    // {
    //   path: '/about',
    //   name: 'about',
    //   // route level code-splitting
    //   // this generates a separate chunk (about.[hash].js) for this route
    //   // which is lazy-loaded when the route is visited.
    //   component: () => import(/* webpackChunkName: "about" */ './views/About.vue'),
    // },
  ],
});
